import { Type } from "class-transformer";
import ResponseEntity, { InputEntity } from "../..";
import { IsInt, ValidateNested, IsBoolean } from "class-validator";
import PrivateUser from "../../user";
import OutputLc from "../../lc";

export default class TransmedCoordinator extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsBoolean() public readonly is_assistant!: boolean;

  @Type(() => PrivateUser)
  @ValidateNested()
  public readonly user!: PrivateUser;

  @Type(() => OutputLc)
  @ValidateNested()
  public readonly lc!: OutputLc;
}

export class TransmedCoordinatorInput extends InputEntity {
  constructor(public readonly public_id: string) {
    super();
  }
}

export class TransmedCoordinatorUpdateInput extends InputEntity {
  public constructor(public is_assistant: boolean) {
    super();
  }
}
